<template>
  <div class="footer">
    <div @click="jump">
      备案信息：宁ICP备2023000130号-1
    </div>
  </div>
</template>

<script>
export default {
  name: "Foot",
  methods: {
    jump() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    },
  },
};
</script>
<style>
.footer {
  text-align: center;
  font-size: 14px;
  color: #8fb0d7;
  position: absolute;
  bottom: 20px;
  left: 0;
  width: 100%;
  z-index: 9999999999;
}
</style>
